let ibiza = document.getElementById('ibiza');
let dubai = document.getElementById('dubai');
let havana = document.getElementById('havana');
let st_moritz = document.getElementById('st-moritz');
let starter = document.getElementById('starter');
let ibiza_price = document.getElementById('ibiza-price');
let dubai_price = document.getElementById('dubai-price');
let havana_price = document.getElementById('havana-price');
let st_moritz_price = document.getElementById('st-moritz-price');
let starter_price = document.getElementById('starter-price');
let heading = document.getElementsByClassName('banner__heading')[0];

function formatPrice(price) {
    let str = price.slice(0, -2);
    str = str + "." + price.slice(-2);
    price = Number(str);
    return price.toLocaleString();
}

switch (heading.textContent.trim().split(" ")[0].toLowerCase()) {
    case 'studio': {
        ibiza.href = '../products/ibiza-pack-studio';
        dubai.href = '../products/dubai-pack-studio';
        havana.href = '../products/havana-pack-studio';
        st_moritz.href = '../products/st-moritz-pack-studio';
        starter.href = '../products/starter-pack-studio';
        ibiza_price.innerHTML = 'AED ' + formatPrice(packageProducts.filter(package => package.handle === "ibiza-pack-studio")[0].price.toString());
        dubai_price.innerHTML = 'AED ' + formatPrice(packageProducts.filter(package => package.handle === "dubai-pack-studio")[0].price.toString());
        havana_price.innerHTML = 'AED ' + formatPrice(packageProducts.filter(package => package.handle === "havana-pack-studio")[0].price.toString());;
        st_moritz_price.innerHTML = 'AED ' + formatPrice(packageProducts.filter(package => package.handle === "st-moritz-pack-studio")[0].price.toString());;
        starter_price.innerHTML = 'AED ' + formatPrice(packageProducts.filter(package => package.handle === "starter-pack-studio")[0].price.toString());;
        break;
    }
    case '1': { 
        ibiza.href = '../products/ibiza-pack-1-bedroom';
        dubai.href = '../products/dubai-pack-1-bedroom';
        havana.href = '../products/havana-pack-1-bedroom';
        st_moritz.href = '../products/st-moritz-pack-1-bedroom';
        starter.href = '../products/starter-pack-1-bedroom';
        ibiza_price.innerHTML = 'AED ' + formatPrice(packageProducts.filter(package => package.handle === "ibiza-pack-1-bedroom")[0].price.toString());
        dubai_price.innerHTML = 'AED ' + formatPrice(packageProducts.filter(package => package.handle === "dubai-pack-1-bedroom")[0].price.toString());
        havana_price.innerHTML = 'AED ' + formatPrice(packageProducts.filter(package => package.handle === "havana-pack-1-bedroom")[0].price.toString());
        st_moritz_price.innerHTML = 'AED ' + formatPrice(packageProducts.filter(package => package.handle === "st-moritz-pack-1-bedroom")[0].price.toString());
        starter_price.innerHTML = 'AED ' + formatPrice(packageProducts.filter(package => package.handle === "starter-pack-1-bedroom")[0].price.toString());
        break;
    }
    case '2': {
        ibiza.href = '../products/ibiza-pack-2-bedroom';
        dubai.href = '../products/dubai-pack-2-bedroom';
        havana.href = '../products/havana-pack-2-bedroom';
        st_moritz.href = '../products/st-moritz-pack-2-bedroom';
        starter.href = '../products/starter-pack-2-bedroom';
        ibiza_price.innerHTML = 'AED '+ formatPrice(packageProducts.filter(package => package.handle === "ibiza-pack-2-bedroom")[0].price.toString());
        dubai_price.innerHTML = 'AED '+ formatPrice(packageProducts.filter(package => package.handle === "dubai-pack-2-bedroom")[0].price.toString());
        havana_price.innerHTML = 'AED '+ formatPrice(packageProducts.filter(package => package.handle === "havana-pack-2-bedroom")[0].price.toString());
        st_moritz_price.innerHTML = 'AED '+ formatPrice(packageProducts.filter(package => package.handle === "st-moritz-pack-2-bedroom")[0].price.toString());
        starter_price.innerHTML = 'AED '+ formatPrice(packageProducts.filter(package => package.handle === "starter-pack-2-bedroom")[0].price.toString());
        break;
    }
    case '3': {
        ibiza.href = '../products/ibiza-pack-3-bedroom';
        dubai.href = '../products/dubai-pack-3-bedroom';
        havana.href = '../products/havana-pack-3-bedroom';
        st_moritz.href = '../products/st-moritz-pack-3-bedroom';
        starter.href = '../products/starter-pack-3-bedroom';
        ibiza_price.innerHTML = 'AED '+ formatPrice(packageProducts.filter(package => package.handle === "ibiza-pack-3-bedroom")[0].price.toString());
        dubai_price.innerHTML = 'AED '+ formatPrice(packageProducts.filter(package => package.handle === "dubai-pack-3-bedroom")[0].price.toString());
        havana_price.innerHTML = 'AED '+ formatPrice(packageProducts.filter(package => package.handle === "havana-pack-3-bedroom")[0].price.toString());
        st_moritz_price.innerHTML = 'AED '+ formatPrice(packageProducts.filter(package => package.handle === "st-moritz-pack-3-bedroom")[0].price.toString());
        starter_price.innerHTML = 'AED '+ formatPrice(packageProducts.filter(package => package.handle === "starter-pack-3-bedroom")[0].price.toString());
        break;
    }
}